<!--
 * @Descripttion: 
 * @version: 
 * @Author: ankeji
 * @Date: 2025-10-20 13:51:30
 * @LastEditors: ankeji
 * @LastEditTime: 2025-11-07 11:10:43
-->
<template>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
